import * as RadixAccordion from '@radix-ui/react-accordion';

type ExpandableListProps = {
  children: React.ReactNode;
};

export function ExpandableList({ children }: ExpandableListProps) {
  return (
    <RadixAccordion.Root type="multiple" className="flex flex-col">
      {children}
    </RadixAccordion.Root>
  );
}
